import "../common/elements/Header.scss";
import InsightsFooter from "./common/InsightsFooter";
import InsightsHeader from "./common/InsightsHeader";
import NavigatorSideNav from "./NavigatorSideNav";
import { InsightsUser } from "../common/interfaces/Interface";

export const InsightsHeaderSidebar = ({
  user,
  children,
  hideNavigatorSideNav
}: {
  user: InsightsUser;
  children: JSX.Element;
  hideNavigatorSideNav?: boolean;
}) => {
  return (
    <div
      className={
        hideNavigatorSideNav
          ? "pagewrapper show-toggle-nav-container"
          : "pagewrapper newHome"
      }
    >
      <InsightsHeader hideNavigatorSideNav={hideNavigatorSideNav} />
      <div className="nav-main">
        {user && user.uuid !== "" && user.roles.includes("administrator") && (
          <NavigatorSideNav
            hideNavigatorSideNav={hideNavigatorSideNav}
            collapseSideNav={true}
          />
        )}
        <main className="contentwrapper background">
          <div id="maincontent">
            {children}
          </div>
          <InsightsFooter />
        </main>
      </div>
    </div>
  );
};
